// Struttura preparata per l'italiano. Le chiavi vuote ricadranno automaticamente sullo spagnolo.
const it = {
  common: {},
  start: {},
  worlds: { list: {} },
  level: {},
  settings: {},
  pause: {},
};
export default it;
